import { pick } from 'lodash-es';
import { post, get } from './client';
import { makeGrowerPath } from './utils';

export function getCertifiedFieldsForGrower(growerId) {
  return get(`/fields/certified/for-edit/by-grower/${growerId}`).then(
    (fields) => fields.map((f) => ({ isCertified: true, ...f })),
  );
}

export function getUncertifiedFieldsForGrower(growerId) {
  return get(`/fields/uncertified/for-edit/by-grower/${growerId}`).then(
    (fields) => fields.map((f) => ({ isCertified: false, ...f })),
  );
}

export function saveUncertifiedField(uncertifiedField, user) {
  return post(makeGrowerPath(`/fields/uncertified/save`), {
    uncertifiedField,
    user,
  });
}

export function deleteUncertifiedFields(fields) {
  return post(makeGrowerPath(`/fields/uncertified/delete`), {
    uncertifiedField: fields.map((f) => pick(f, ['aaManagedId', 'fieldName'])),
  });
}

export function combineUncertifiedFields(uncertifiedFields) {
  return post(makeGrowerPath(`/fields/uncertified/combine`), {
    uncertifiedFields,
  });
}

export function splitUncertifiedField(
  uncertifiedField,
  boundary1,
  boundary2,
  user,
) {
  return post(makeGrowerPath(`/fields/uncertified/split`), {
    uncertifiedField,
    boundary1,
    boundary2,
    user,
  });
}

export function explodeUncertifiedField(uncertifiedField, boundaries, user) {
  return post(makeGrowerPath(`/fields/uncertified/explode`), {
    uncertifiedField,
    boundaries,
    user,
  });
}

export function validateUncertifiedFields(uncertifiedFieldIds) {
  return post(
    makeGrowerPath(`/fields/uncertified/validate`),
    uncertifiedFieldIds,
  );
}

export function certifyFields(uncertifiedFieldIds) {
  return post(makeGrowerPath(`/fields/uncertified/certify`), {
    uncertifiedFieldIds,
  });
}

export function uncertifyFields(certifiedFields) {
  return post(makeGrowerPath(`/fields/certified/uncertify-bulk`), {
    certifiedFields,
  }).then(() => certifiedFields);
}

export function bulkUpdateFields(editInfo) {
  return post(makeGrowerPath(`/fields/bulk-update-attributes`), editInfo);
}

export function reassignFields(growerId, reassignedFields) {
  return post(`/growers/${growerId}/fields/reassignment`, reassignedFields);
}
